import { render, staticRenderFns } from "./fruit.vue?vue&type=template&id=37151d32&scoped=true"
import script from "./fruit.vue?vue&type=script&lang=js"
export * from "./fruit.vue?vue&type=script&lang=js"
import style0 from "./fruit.vue?vue&type=style&index=0&id=37151d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37151d32",
  null
  
)

export default component.exports